import { Injectable, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { EventsConstant } from "../shared/constants/eventsConstant";
import { apiUrlConstant } from "../utils/constant/apiUrl.constant";
import { EVENT, LOCAL_STORAGE_KEYS } from "../utils/enum";
import { ApiService } from "./api.service";
import { SharedDataService } from "./dataservice";
import { EventService } from "./event.service";
import { LocalStorageProvider } from "./localStorage";

@Injectable({
  providedIn: "root",
})
export class CommonFunctions implements OnDestroy {
  subscriptions: Subscription[] = [];
  prefrenceCurrency = "usd";

  constructor(
    public router: Router,
    public apiservice: ApiService,
    private eventService: EventService,
    public commonData: SharedDataService,
    private localStorageService: LocalStorageProvider,
  ) { }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  openInNewTab(route: any) {
    // Converts the route into a string that can be used
    // with the window.open() function
    const url = this.router.serializeUrl(this.router.createUrlTree([route]));

    window.open(url, "_blank");
  }

  convertToString(num: any) {
    let nsign = Math.sign(num);
    //remove the sign
    num = Math.abs(num);
    //if the number is in scientific notation remove it
    if (/\d+\.?\d*\d+/i.test(num)) {
      let zero = "0",
        parts = String(num).toLowerCase().split("e"), //split into coeff and exponent
        e: any = parts.pop(), //store the exponential part
        l = Math.abs(e), //get the number of zeros
        sign = e / l;
      let coeff_array: any;
      if (parts.length > 0) {
        coeff_array = parts[0].split(".");
        if (sign === -1) {
          num = this.ifPortion(l, coeff_array, zero);
        } else {
          num = this.elsePortion(l, coeff_array, zero);
        }
      }
    }
    return nsign < 0 ? "-" + num : num;
  }

  ifPortion(l: number, coeff_array: any[], zero: string): any {
    let num: any;
    l = l - coeff_array[0].length;
    if (l < 0) {
      num =
        coeff_array[0].slice(0, l) +
        "." +
        coeff_array[0].slice(l) +
        (coeff_array.length === 2 ? coeff_array[1] : "");
    } else {
      num = zero + "." + new Array(l + 1).join(zero) + coeff_array.join("");
    }
    return num;
  }

  elsePortion(l: number, coeff_array: any[], zero: string): any {
    let dec = coeff_array[1];
    let num: any;
    if (dec) l = l - dec.length;
    if (l < 0) {
      num = coeff_array[0] + dec.slice(0, l) + "." + dec.slice(l);
    } else {
      num = coeff_array.join("") + new Array(l + 1).join(zero);
    }
    return num;
  }

  getWallet(currency?: string) {
    let getWallet = this.prefrenceCurrency;
    if (currency) {
      getWallet = currency;
    }
    this.apiservice
      .getData(apiUrlConstant.getWallet + getWallet)
      .subscribe({
        next: (res) => {
          if (res?.success) {
            let totalBalance =
              res?.result[0]?.available_balance + res?.result[0]?.locked_balance;
            if (res?.result[1]) {
              // NOTE: If token wallet is present then add it to total balance. available_balance and locked_balance are no of tokens
              totalBalance +=
                (res?.result[1].available_balance +
                  res?.result[1]?.locked_balance) *
                res?.result[1].price;
            }
            this.commonData.setTotalBal(totalBalance ?? 0);
            this.localStorageService.setItem(
              LOCAL_STORAGE_KEYS.WALLET_DETAILS,
              res?.result,
            );
            this.commonData.setWalletBalance(res?.result[0]?.available_balance);
            this.eventService.broadcastEvent(EVENT.REFRESH_WALLET, true);
          }
        }, error: (error: any) => {
          this.localStorageService.setItem(
            LOCAL_STORAGE_KEYS.WALLET_DETAILS,
            0,
          );
          this.commonData.setWalletBalance(0);
        }
      });
  }

  getWalletV1(balanceInfo: any) {
    if (balanceInfo) {
      let totalBalance =
        balanceInfo[0]?.available_balance + balanceInfo[0]?.locked_balance;
      if (balanceInfo[1]) {
        // NOTE: If token wallet is present then add it to total balance. available_balance and locked_balance are no of tokens
        totalBalance +=
          (balanceInfo[1].available_balance +
            balanceInfo[1]?.locked_balance) *
          balanceInfo[1].price;
      }
      this.commonData.setTotalBal(totalBalance ?? 0);
      this.localStorageService.setItem(
        LOCAL_STORAGE_KEYS.WALLET_DETAILS,
        balanceInfo,
      );
      this.commonData.setWalletBalance(balanceInfo[0]?.available_balance);
      this.eventService.broadcastEvent(EVENT.REFRESH_WALLET, true);
    } else {
      this.localStorageService.setItem(
        LOCAL_STORAGE_KEYS.WALLET_DETAILS,
        0,
      );
      this.commonData.setWalletBalance(0);
    }
  }

  getWalletDetails() {
    this.subscriptions.push(
      this.apiservice.getData(apiUrlConstant.getBanks).subscribe({
        next: (res) => {
          if (res.success) {
            this.eventService.broadcastEvent(
              EventsConstant.REFRESH_BANK_DETAILS,
              res.result,
            );
          }
        },
        error: (err) => {
          console.log(err);
        },
      }),
    );
  }
}
